var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4"},[_c('p',{staticClass:"font-italic mb-4"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('textarea',{staticClass:"form-control",attrs:{"name":"","cols":"30","rows":"2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }